import { getRequiredStarSignalCount } from '../helpers';

// Shared by the live render guard and the editor's info note so the wording only lives in one place.
export default function StarSignalCountMessage({ visualizationName, boldClassName }) {
  return (
    <>
      <span className={boldClassName}>{visualizationName}</span> visualizations require{' '}
      <span className={boldClassName}>{getRequiredStarSignalCount('vectors')} signals</span> in
      vector mode, or{' '}
      <span className={boldClassName}>{getRequiredStarSignalCount('cartesian')} signals</span> in
      cartesian mode
    </>
  );
}
